import { Phone, MapPin, Clock, AlertCircle } from 'lucide-react';
import { companyInfo, disclaimer, whatsappLink } from '../data/mock';
import { WhatsAppIcon } from './WhatsAppIcon';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_laser-busters/artifacts/2ala9m3d_Screenshot_2026-01-31-00-11-44-62_92460851df6f172a4592fca41cc2d2e6.jpg";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer 
      className="py-12 px-6"
      style={{ 
        background: 'var(--bg-dark)',
        borderTop: '1px solid var(--border-gold)'
      }}
    >
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img 
                src={LOGO_URL} 
                alt="Borer Busters Logo" 
                className="h-16 w-auto object-contain"
              />
            </div>
            <p 
              className="body-small mb-4"
              style={{ color: 'var(--text-muted)' }}
            >
              South Mumbai's premier laser-based wood borer treatment service. 
              One treatment. Durable results.
            </p>
            <div 
              className="inline-block px-3 py-1 rounded font-display font-bold text-sm"
              style={{ 
                background: 'linear-gradient(90deg, var(--gold-dark), var(--gold-primary))',
                color: 'var(--bg-dark)'
              }}
            >
              Starting ₹{companyInfo.startingPrice}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 
              className="font-display font-semibold mb-4 uppercase tracking-wider"
              style={{ color: 'var(--gold-primary)' }}
            >
              Contact Us
            </h4>
            <div className="space-y-3">
              <a 
                href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
                className="flex items-center gap-3 hover:opacity-80 transition-opacity"
                style={{ color: 'var(--text-light)', textDecoration: 'none' }}
              >
                <Phone size={18} style={{ color: 'var(--gold-primary)' }} />
                <span className="font-mono">{companyInfo.phone}</span>
              </a>
              <a 
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                className="flex items-center gap-3 hover:opacity-80 transition-opacity"
                style={{ color: 'var(--text-light)', textDecoration: 'none' }}
              >
                <span style={{ color: '#25D366', display: 'inline-flex' }}>
                  <WhatsAppIcon size={18} />
                </span>
                <span className="font-mono">WhatsApp Chat</span>
              </a>
              <div 
                className="flex items-center gap-3"
                style={{ color: 'var(--text-muted)' }}
              >
                <MapPin size={18} style={{ color: 'var(--gold-primary)' }} />
                <span>South Mumbai</span>
              </div>
              <div 
                className="flex items-center gap-3"
                style={{ color: 'var(--text-muted)' }}
              >
                <Clock size={18} style={{ color: 'var(--gold-primary)' }} />
                <span>By Appointment Only</span>
              </div>
            </div>
          </div>

          {/* Service Areas */}
          <div>
            <h4 
              className="font-display font-semibold mb-4 uppercase tracking-wider"
              style={{ color: 'var(--gold-primary)' }}
            >
              Service Areas
            </h4>
            <div className="grid grid-cols-2 gap-2">
              {['Colaba', 'Cuffe Parade', 'Nariman Point', 'Marine Drive', 'Malabar Hill', 'Breach Candy', 'Worli', 'Lower Parel'].map((area, index) => (
                <span 
                  key={index} 
                  className="body-small"
                  style={{ color: 'var(--text-muted)' }}
                >
                  {area}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <div 
          className="mb-8 p-4 rounded-lg"
          style={{ 
            background: 'rgba(139, 0, 0, 0.1)',
            border: '1px solid rgba(196, 30, 30, 0.3)'
          }}
        >
          <div className="flex items-start gap-3">
            <AlertCircle size={18} style={{ color: 'var(--red-accent)', flexShrink: 0, marginTop: '2px' }} />
            <div>
              <p 
                className="body-small font-semibold mb-1"
                style={{ color: 'var(--text-light)' }}
              >
                {disclaimer.title}
              </p>
              <p 
                className="text-xs"
                style={{ color: 'var(--text-muted)', lineHeight: 1.6 }}
              >
                {disclaimer.text}
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div 
          className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4"
          style={{ borderTop: '1px solid var(--border-gold)' }}
        >
          <p 
            className="body-small"
            style={{ color: 'var(--text-muted)' }}
          >
            © {currentYear} Borer Busters. All rights reserved.
          </p>
          <div className="flex items-center gap-3">
            <a 
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-btn"
              className="flex items-center gap-2 text-sm py-2 px-4 rounded font-display font-semibold transition-transform hover:-translate-y-0.5"
              style={{ 
                background: '#25D366',
                color: '#fff',
                textDecoration: 'none'
              }}
            >
              <WhatsAppIcon size={16} />
              <span>WhatsApp</span>
            </a>
            <a 
              href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
              className="btn-outline-gold text-sm"
            >
              <Phone size={16} />
              <span>Call Now</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
